import React, { useContext, useEffect, useState } from "react";
import { Route, useLocation } from "react-router-dom";

import LoadingPage from "../loadingPage/LoadingPage";
import Navbar from "../navbar/Navbar.component";
import Dashboard from "../dashboard/Dashboard.component";
import Plans from "../plans/Plans.component";
import Support from "../support/Support.component";
import Setup from "../setup/Setup";
import IntFacebook from "../setup/facebook/IntFacebook";
import IntGoogle from "../setup/IntGoogle";
import SelectFBAccount from "../setup/facebook/SelectFBAccount";
import TrackConversions from "../setup/TrackConversions";
import SignIn from "../signIn/SignIn.component";
import SignUp from "../signUp/SignUp.componenet";
import PasswordReset from "../passwordReset/PasswordReset.component";
import FixelDataContext from "../../context/FixelDataContext";
import usePageViews from "../../customHooks/usePageViews";
import { StyledInnerContainer, StyledMainContainer } from "./main.styled";
import ConnectPlatforms from "../setup/ConnectPlatforms";
import Firebase from "../../services/firebase"
import {useAuthState} from "react-firebase-hooks/auth";
import {
  doesHaveSegments,
  getFBAudiences,
  getFixelData,
  getHostname,
  verifyCustomer,
  wpUrl
} from "../../services/globalService";
import prepFixelFullRes, {getFromStorage, prepFBAudiences, setToStorage} from "../../services/dataService";
import {useHistory} from "react-router-dom";
import Checkout from "../checkout/Checkout.component";
import {useCustomer} from "../../provider/customerProvider";
import axios from "axios";
import ErrorPage from "../utils/errorPage/ErrorPage";
import Introduction from "../introduction/Introduction.component";
import CancelPlan from "../plans/CancelPlan.component";
import AreYouSure from "../plans/AreYouSure";

if(Firebase.auth.currentUser){
  Firebase.refreshToken().then(r => localStorage.setItem("token",r));
}

// create an axios interceptor for when 401 IS recieved
const axiosAgent = axios.create({withCredentials: true});
axiosAgent.interceptors.response.use(
    (response) => response,
    async (error) => {
      if(error.response.status === 401){
        try {
          await Firebase.refreshToken();
        }catch (err){
          throw err;
        }
      }}
)

const Main = () => {

  usePageViews(useLocation());
  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
  const location = useLocation();
  const history = useHistory();
  const [user] = useAuthState(Firebase.auth);
  const [haveData, setHaveData] = useState(false);
  const [haveSegments, setHaveSegments] = useState(false)
  const {customer, setCustomer, setLoading} = useCustomer();

  useEffect(()=> {
    if( getFromStorage('fxl_check_segment') ){
      setHaveSegments(true);
      return;
    }
    if(customer?.email) {
      doesHaveSegments(customer.email).then((result) => {
        if(result?.data) {
          const {data} = result;
          setToStorage('fxl_check_segment', 1);
          setHaveSegments(data);
        }
      })
    }
  },[customer])
  /**
   * Effect for setting up customer
   */
  useEffect( () => {
    const validateCustomer = () => {

      //check if cached
      if( getFromStorage('fxl_validate_customer') ){
        setCustomer(user);
        return;
      }
      verifyCustomer(user).then(function (res){
        if(res?.data?.data && JSON.parse(res.data.data) && res.data.success ){
          setToStorage('fxl_validate_customer', 1);
          setCustomer(user);
        }else {
          setLoading(false);
          // handle responses
          if(!res?.data?.success && res?.data?.data[0]?.code === 503) {
            history.push('/errorPage');
          }
          history.push('/');
        }
      });
    }

    if(user && !customer) {
      setLoading(true);
      validateCustomer();
      history.push('/');
    }
  },[user,history,customer,setCustomer,setLoading])

  useEffect(() => {

    const renderFixelData = async () => {
        try {
          if(!sessionStorage.token){
            await Firebase.refreshToken();
            sessionStorage.token = await Firebase.auth.currentUser.getIdToken();
          }
          let newFixelData = {};
          const fullDataResponse = await getFixelData(
              'post',
              wpUrl,
              {
                token : sessionStorage.token,
                action : 'get_fixel_data',
                email : user.email,
                display: getHostname(window.location.hostname)
              }
          )

          if(!fullDataResponse?.data?.success){ // check 204 in the future
            if(fullDataResponse.data && fullDataResponse.data.data && fullDataResponse.data.data[0] && fullDataResponse.data.data[0].code==="no segment")
              return history.push('/introduction');
          }
          const dataResponse = JSON.parse(fullDataResponse.data);

          // check data response
          // prep data
          if(process.env.NODE_ENV !== 'production') {
            console.info('preparing data', dataResponse);
          }
          const data = prepFixelFullRes(dataResponse);
          if(process.env.NODE_ENV !== 'production') {
            console.info('Function: renderFixelData, Line 117 (data): ', data);
          }
          if (data) {
            newFixelData = { ...newFixelData, ...data };
            setFullFixelData(newFixelData);

            getFBData(newFixelData?.install_data?.options?.fb, newFixelData.code).then((FBDataRes)=>{
              newFixelData = { ...newFixelData, facebook: FBDataRes };
              setFullFixelData(newFixelData);
            });
          }


        } catch (error) {
          console.error("🚀 ~ file: Main.component.js ~ line 78 ~ getFixelData ~ error", error);
          await Firebase.refreshToken();
          return history.push('/errorPage');
        }
    };
    if(user && customer && haveSegments) {
      renderFixelData();
    }

  }, [customer, setFullFixelData, user, haveSegments, history]);

  const getFBData = async (isFbOn,fixel_code) => {
    try {
      if (isFbOn) {
        if(process.env.NODE_ENV !== 'production') {
          console.info('getting facebook audiences');
        }
        const FBAudiences = await getFBAudiences(fixel_code);
        const showFBAudiences =
            FBAudiences &&
            FBAudiences.data.data &&
            FBAudiences.data.data.length &&
            !FBAudiences.data.data[0].disabled;
        if(process.env.NODE_ENV !== 'production') {
          console.log('Function: getFBData, Line 152 (showFBAudiences): ', FBAudiences);
        }
        if (showFBAudiences) {
          return {
            audience: prepFBAudiences(FBAudiences.data.data),
            status: "connected",
            showFBAudiences: true,
          };
        }
      }
      return { status: "not connected", showFBAudiences: false };
    } catch (error) {
      console.error("TCL ~ file: LoadingPage.js ~ getFbAudience ~ error", error.message || error);
    }
  };


  useEffect(() => {
    if(typeof fullFixelData !== 'undefined') {
      setHaveData(!!fullFixelData.state);
    }
  }, [fullFixelData]);

  const noNavbarPages = ["/", "/introduction", "/errorPage", "/signin", "/signup", "password-reset"];
  const showNav = !noNavbarPages.includes(location.pathname);

  return (
    <StyledMainContainer>
      { showNav && <Navbar />}
      <StyledInnerContainer>
        <Route exact path={'/'} render={(props) => <LoadingPage {...props} haveData={haveData} haveSegments={haveSegments}/>}/>
        <Route exact path="/errorPage" component={ErrorPage} />
        <Route exact path="/introduction" component={Introduction} />
        <Route exact path="/setup" component={Setup} />
        <Route exact path="/setup/conversions" component={TrackConversions} />
        <Route exact path="/setup/connectPlatforms" component={ConnectPlatforms} />
        <Route exact path="/setup/facebook" component={IntFacebook} />
        <Route exact path="/setup/facebook/selectAccount" component={SelectFBAccount} />
        <Route exact path="/setup/google" component={IntGoogle} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/plans" component={Plans} />
        <Route exact path="/plans/checkout/:planId" component={Checkout} />
        <Route exact path="/plans/cancel/:planId" component={CancelPlan} />
        <Route exact path="/plans/cancel/:planId/confirmation" component={AreYouSure} />
        <Route exact path="/support" component={Support} />
        <Route exact path="/signup" component={SignUp} />
        <Route exact path={'/signin'} component={SignIn}/>
        <Route exact path="/password-reset" component={PasswordReset} />
      </StyledInnerContainer>
    </StyledMainContainer>
  );
};
export default Main;
